import React from 'react'
import { Outlet } from 'react-router-dom'
import { Grid } from '@mui/material'

const NoLayoutTemplate = () => {
  return (
    <>
      <Grid item sx={{ flex: 1 }}>
        <main>
          <Outlet />
        </main>
      </Grid>
    </>
  )
}

export default NoLayoutTemplate
